import { AfterViewInit, Component, Renderer2, Inject, Input, Optional } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { UntypedFormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { avsconfig_sow } from '@environments/environment';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { LugasLimitDialog } from './lugas-limit.dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { UserHelper } from '@app/helpers/user.helper';

declare let window;

@Component({
  selector: 'verification-sow-component',
  templateUrl: '../sharedTemplates/verification-sow-component.html',
})
export class VerificationSowUpload implements AfterViewInit {
  title: string;
  uploadDoc: UntypedFormGroup;
  uploadDocRaw: any;
  input_filepath = '';
  input_isdisabled = '';
  fileCaseControl: any;

  file;
  hasInsicToken = false;
  interval: any;
  @Input() showInfoContainer = true;
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    public _Router: Router,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private renderer2: Renderer2,
    public _UserHelper: UserHelper,

    @Optional() public dialogRef: MatDialogRef<LugasLimitDialog>,
    @Inject(DOCUMENT) private _document
  ) {
    this.registerSow();
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Personal_Documents', false);
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();
  }
  s;
  getToken() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getInsicSOWToken()
      .then(result => {
        //this._UiHelper.setLoadingDialog(false);
        if (result != '') {
          this.hasInsicToken = true;
          //console.warn(avsconfig_online.resourceUrl);
          window.__AVS_CONFIG__ = {
            apiUrl: avsconfig_sow.apiUrl,
            resourceUrl: avsconfig_sow.resourceUrl,
            partnerId: avsconfig_sow.partnerId,
            token: result,
            startRoute: '/login',
            registrationType: 'simple',
            lang: this._LocalizationService.LANGCODE,
          };

          this.s = this.renderer2.createElement('script');
          this.s.type = 'text/javascript';
          this.s.src = avsconfig_sow.resourceUrl + 'static/js/avs-loader.min.js';
          this.s.text = ``;
          this.renderer2.appendChild(this._document.body, this.s);
          this.checkCustomerFinSchufa();
        }
      })
      .finally(() => this._UiHelper.setLoadingDialog(false));
  }
  OpenAccountMobile(selectMenu) {
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }
  ngOnDestroy() {
    try {
      if (this.s && window.AVS_UNMOUNT()) {
        window.AVS_UNMOUNT();
      }
    } catch (error) {
      console.log('error');
    }
    clearInterval(this.interval);
  }
  registerSow() {
    const translator = new TranslatePipe(this._LocalizationService);

    this._ApiService.registerSow().then(result => {
      if (result === '""') {
        const t_message = translator.transform('b3000_Withdraw_Text_2', null);

        this._UiHelper.errorSnackBar(t_message, '');
        return 'error|System Error';
      } else {
        this.getToken();
      }
    });
  }
  checkCustomerFinSchufa() {
    if (this.showInfoContainer === false) {
      const translator = new TranslatePipe(this._LocalizationService);

      this.interval = setInterval(() => {
        this._ApiService
          .getCustomerFinSchufa()
          .then(x => {
            if (x && x.Data && x.Data.length > 0 && x.Data[0].IsSchufa === true) {
              const t_message = translator.transform('upload_successful', null);
              this._UiHelper.successSnackBar(t_message, '');

              this.setLimit();
              this.dialogRef.close();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }, 5000);
    }
  }

  setLimit() {
    this._ApiService.saveSelfLimits2(10000, 2, 3).then(result => {
      const translator = new TranslatePipe(this._LocalizationService);

      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');
          this._ApiService.getClient().then(u => {
            this._UserHelper.setUser(u);
          });
        }
      }
    });
  }
}
